import { Button, ExplainerBanner } from '@/ds'
import { formatMoney } from '@/lib/format'
import { useAppNavigate } from '@/lib/query-params'
import type { PendingChangePayment } from '@/services/reserva'
import { PAY_ROUTES } from '../Pagos/shared'
import { changeQuery, dayOf, longRange, useLang } from './shared'
import type { ChangeOrigin } from './shared'

/**
 * "Cambio pendiente de pago" (D45): el cambio está aplicado en la reserva pero su cobro no se completó y no se pudo
 * volver a las fechas anteriores. Se muestra en Reserva y en Tu estancia con la acción de pagar lo pendiente (E2).
 */
export function PendingChangeBanner({ pending, className, origin = 'reserva' }: { pending: PendingChangePayment; className?: string; origin?: ChangeOrigin }) {
  const { t, lang } = useLang()
  const { go } = useAppNavigate()
  const amount = formatMoney(pending.amount, lang)
  return (
    <div className={className ? `reserva__pending ${className}` : 'reserva__pending'}>
      <ExplainerBanner tone="warning" title={t('v2.reserva.pendiente.titulo')}>
        {t(`v2.reserva.pendiente.texto.${pending.type}`, { amount, range: longRange(dayOf(pending.newCheckIn), dayOf(pending.newCheckOut), lang, t) })}
      </ExplainerBanner>
      <Button onClick={() => go(PAY_ROUTES.payments, { query: changeQuery(origin) })}>{t('v2.reserva.pendiente.pagar', { amount })}</Button>
    </div>
  )
}
